// customer-layout.component.ts
import { CommonModule } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  selector: 'app-customer-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './customer-layout.component.html',
  styleUrls: ['./customer-layout.component.css'],
})
export default class CustomerLayoutComponent {
  private readonly router = inject(Router);

  private currentUrl = toSignal(
    this.router.events.pipe(map(() => this.router.url)),
    { initialValue: this.router.url }
  );

  activeTab = computed<'notice' | 'faq'>(
    () => {
      const url = this.currentUrl();

      if (url.includes('/customer/notice')) return 'notice';
      if (url.includes('/customer/faq')) return 'faq';

      return 'notice';
    }
  );

  changeTab(tab: 'notice' | 'faq') {
    this.router.navigate(['/customer', tab]);
  }
}
